import { render, staticRenderFns } from "./BannerLayout.vue?vue&type=template&id=d1dcca40&scoped=true"
import script from "./BannerLayout.vue?vue&type=script&lang=js"
export * from "./BannerLayout.vue?vue&type=script&lang=js"
import style0 from "./BannerLayout.vue?vue&type=style&index=0&id=d1dcca40&prod&lang=css"
import style1 from "./BannerLayout.vue?vue&type=style&index=1&id=d1dcca40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1dcca40",
  null
  
)

export default component.exports